import { useQuery } from '@tanstack/react-query';
import { dashboardApi, dashboardQueryKeys } from '../api/dashboard.api';

export function useLawyerKpi() {
  return useQuery({
    queryKey: dashboardQueryKeys.lawyerKpi(),
    queryFn: () => dashboardApi.getLawyerKpi(),
  });
}
